/**
 * Recorre las cards de partido visibles en el contenedor scrolleable (.content_div)
 * y devuelve sus data-match-name como un array de strings.
 *
 * Se ejecuta solo al cruzar un threshold de scroll — el costo es despreciable.
 */
export const getVisibleMatchNames = () => {
  const container = document.querySelector('.content_div');
  if (!container) return [];

  const containerRect = container.getBoundingClientRect();
  const cards = container.querySelectorAll('[data-role="mundial2026-match-card"]');
  const visible = [];

  cards.forEach((card) => {
    const rect = card.getBoundingClientRect();
    const isVerticallyVisible = rect.bottom > containerRect.top && rect.top < containerRect.bottom;
    const isHorizontallyVisible = rect.right > containerRect.left && rect.left < containerRect.right;

    if (isVerticallyVisible && isHorizontallyVisible) {
      const name = card.getAttribute('data-match-name');
      if (name) visible.push(name);
    }
  });

  return visible;
};
